import { Typography } from "@material-ui/core";

const TeacherPortalStudentGeneralInformationTab = ({ student }) => {
    return <Typography>Student ID: {student.user.userid}</Typography>
}


export default TeacherPortalStudentGeneralInformationTab